import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import { colorFacetGroups, colorFacetImages } from "../../config"

function ColorGroup({ facet, group }) {
    const { toggleProductFilter } = useFacet(facet)
    const filterValues = useMemo(() => facet?.data?.length > 0 ? facet.data.filter(d => group.values.includes(d.value)) : null, [ facet.data, group ])

    return (
        <li>
            <div class="[&amp;:has(.filter-items:empty)]:hidden">
                <div
                    class="w-full min-h-[60px] flex justify-center items-center bg-repeat bg-cover bg-center mb-xs border border-t-ui-lines-2 text-t-brand-primary-contrast"
                    style={`background: url(${group.titleBg})`}
                >
                    {group.name}
                </div>
                <p class="caption text-center mb-xs text-t-foreground">
                    {group.desc}
                </p>
                <div class="grid grid-cols-2 gap-2xs mb-md filter-items">
                    {filterValues.map(value => {
                        const valueName = value.value.replaceAll(' ', '-').replaceAll('/', '-').trim().toLowerCase();
                        const inputId = `facet-${facet.id}-filter-${valueName}`
                        return (
                            <label class="block cursor-pointer" tabindex={0}>
                                <input
                                    id={inputId}
                                    value={value.value}
                                    type="checkbox" 
                                    class="peer hidden"
                                    checked={value.selected}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        toggleProductFilter(facet.field, value.value, !value.selected);
                                    }}
                                />
                                <div class="flex items-center gap-xs p-2xs border border-t-ui-lines-2 peer-checked:active peer-checked:border-t-foreground-secondary text-t-foreground peer-disabled:text-t-disabled peer-checked:text-t-foreground-secondary">
                                    <img
                                        class="w-10 h-10 min-w-10"
                                        src={colorFacetImages[value.value]}
                                        alt={`Color ${value.value}`}
                                        width="40"
                                        height="40"
                                        loading="lazy"
                                    />
                                    <h5 class="caption">{value.value}</h5>
                                </div>
                            </label>
                        )
                    })}
                </div>
            </div>
        </li>
    )
}

export default function FacetColors({ facet }) {

    return (
        <details class="js-filter border-b border-t-ui-lines-2 px-sm group/filter-dropdown" aria-labelledby={`facet-heading-${facet.id}`}>
            <summary class="ns-facet-heading focus-inset flow-root py-lg md:py-md cursor-pointer" data-nosto-element="facet">
                <div class="flex w-full items-center justify-between">
                    <h6 id={`facet-heading-${facet.id}`} class="caption-large uppercase">
                        {facet.name}
                    </h6>
                    <svg fill="none" class="icon icon-plus" viewBox="0 0 10 10" aria-label="Plus icon" role="presentation"  focusable="false">
                        <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path>
                    </svg>
                    <svg fill="none" class="icon icon-minus" id="icon-minus" viewBox="0 0 10 2" aria-label="Minus icon" role="presentation" focusable="false">
                        <path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path>
                    </svg>
                </div>
            </summary>
            
            <div class="pb-6">
                <ul class="list-unstyled space-y-xs" role="menu">
                    {colorFacetGroups.map(group => (
                        <ColorGroup
                            key={group.name}
                            facet={facet}
                            group={group}
                        />
                    ))}
                </ul>
            </div>
        </details>
    )
}
